import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import { useMemo } from 'react';

type MachineType = AxiosResponse<
  {
    id: number;
    type: string;
  }[]
>;

const useMachineTypeQuery = () => {
  const query = useQuery<MachineType>({
    queryKey: ['machine-type'],
    queryFn: () => API.get('/machine-owner/machine-types'),
  });

  const machineTypeOptions = useMemo(
    () => query.data?.data?.map((val) => ({ value: val.id, label: val.type })),
    [query.data],
  );

  return { ...query, machineTypeOptions };
};

export default useMachineTypeQuery;
